import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.grant-report-access-to-all-secondary-categories.GrantReportAccessToAllSecondaryCategoriesPresenter`

export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Success',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage:
      '{userFullName} was successfully added to all {pluralSecondaryOrgCategoryLabel} in {primaryCategoryName}.',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage:
      'Unable to give the user report access to all {pluralSecondaryOrgCategoryLabel}. Please try again.',
  },
})
